// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC8yuxfmWZSZSDDmwdoZDN1sflnPnndpvE",
  authDomain: "cutthroat-spades.firebaseapp.com",
  projectId: "cutthroat-spades",
  storageBucket: "cutthroat-spades.appspot.com",
  messagingSenderId: "699575750232",
  appId: "1:699575750232:web:8d7ebbfd7a7bb5c866842d"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Initialize Firestore with persistent cache
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});
